module.exports = __webpack_public_path__ + "static/ttl-registration-certificate-5155f522707721793b4615132427732f.pdf";